import { createSlice } from "@reduxjs/toolkit";

export const filters = createSlice({
  name: "filters",
  initialState: {
    selectedFloor: "all",
    selectedZones: [],
    excludedDepartments: [],
    allFloors: [],
    allZones: [],
    allDepartments: [],
  },
  reducers: {
    updateSelectedFloor: (state, action) => {
      state.selectedFloor = action.payload;
    },
    updateSelectedZones: (state, action) => {
      state.selectedZones = action.payload;
    },
    addExcludedDepartment: (state, action) => {
      if (!state.excludedDepartments.includes(action.payload)) {
        state.excludedDepartments.push(action.payload);
      }
    },
    removeExcludedDepartment: (state, action) => {
      state.excludedDepartments = state.excludedDepartments.filter(
        (dept) => dept !== action.payload
      );
    },
    setAllFloors: (state, action) => {
      state.allFloors = action.payload;
    },
    setAllZones: (state, action) => {
      state.allZones = action.payload;
    },
    setAllDepartments: (state, action) => {
      state.allDepartments = action.payload;
    },
  },
});

export const {
  updateSelectedFloor,
  updateSelectedZones,
  addExcludedDepartment,
  removeExcludedDepartment,
  setAllFloors,
  setAllZones,
  setAllDepartments,
} = filters.actions;

export default filters.reducer;
